import Env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';
import {GET_CLIENT_REQUEST} from '../actiontypes';

export function getClientRequest(projectId, entities) {
	const url = `${Env.getBaseURL(serviceURL)}projects/${projectId}/ClientRequestInquiry`;
	const payload = {
		entityIds: entities
	};
	return {
		type: GET_CLIENT_REQUEST,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: payload
			}
		}
	};
}
